<template>
    <div class="categ_info" v-if="obj_to_null(this.item)">
        <info_field f_uniq="ct" f_type="title" @update_categ="change_atr" :is_disabled=false :f_title="__t('NAME')" :f_val="cur_item.title"></info_field>

        <yes_no
            @change="change_atr('group_type', $event)"
            key="group_type"
            v-model="cur_item.group_type"
            :radio_options="group_types"
            title="GROUP_TYPE">

        </yes_no>



        <info_field f_uniq="ct_al" f_type="alias"  @update_categ="change_atr" :f_title="__t('ALIAS')" :f_val="cur_item.alias"></info_field>
        <div class="form-group mt-2">
            <label class="form-label" for="intro_html">
                {{ __t('INTRO_PROD_HTML') }}
            </label>


            <div class="input-group flex-nowrap d-block">
                <vue-editor :editor-toolbar="editor_rules"  v-model="item.description"></vue-editor>
            </div>
        </div>
    </div>
</template>

<script>
import Info_field from "../../../../../sys/info_field";
import { VueEditor } from "vue2-editor";
import yes_no from "../../../../../sys/radio/yes_no.vue";
export default {
    name: "pwa_group_info",
    components : {yes_no, Info_field,VueEditor},
    props : {
        item : {
            type : Object
        }
    },

    data() {
        return {
            cur_item : this.item,
            is_load: false,
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
        }
    },

    methods :  {
        change_atr(atr_name,atr_val) {
            console.log(atr_name,atr_val);
            this.$emit('on_group_change',{
                "type"      : atr_name,
                "value"     : atr_val,
            })
        }
    },

    computed : {
        group_types() {
            return this.cur_item.group_types.map(item => {
                return {
                    "value" : item,
                    'text' : this.__t('PWA_NEWS.' + item.toUpperCase()) ,
                }
            })
        },
    }
}
</script>



<style scoped>

</style>
